<template>
<div class="container">
    <div class="nj-title-1">Crear Cuenta</div>
    <div class="nj-panel">
        <div class="nj-panel-content">
            <!-- // * Datos de la empresa -->
            <div class="nj-title-2">Datos de la empresa</div>
            <div class="nj-grid">
                <InputText label="RUC" v-model="proveedor.pve_ruc">
                    <template #default="data">
                        <Button label="Buscar" icon="search" @click="obtenerDatos(data.value)"></Button>
                    </template>
                </InputText>
                <InputText label="Razon social" v-model="proveedor.pve_razon_social" :disabled="true"></InputText>
                <InputText label="Teléfono" v-model="proveedor.pve_telefono" :disabled="true"></InputText>
                <InputText label="Correo" v-model="proveedor.pve_correo" :disabled="true"></InputText>
            </div>
            <div class="nj-grid c2">
                <InputText label="Dirección" v-model="proveedor.pve_direccion" :disabled="true"></InputText>
                <InputText label="Especialidad" v-model="proveedor.pve_especialidad" :disabled="true"></InputText>
                <InputText label="Cuenta de detracción" v-model="proveedor.pve_cuenta_detraccion" :disabled="true"></InputText>
            </div>
            <!-- // * Datos del usuario -->
            <div class="nj-line"></div>
            <div class="nj-title-2">Datos del usuario</div>
            <div class="nj-grid">
                <InputText label="Correo (usuario)" v-model="usuario.usu_correo"></InputText>
                <InputText label="DNI" v-model="usuario.usu_dni"></InputText>
                <InputText label="Nombres" v-model="usuario.usu_nombre"></InputText>
                <InputText label="Apellidos" v-model="usuario.usu_apellido"></InputText>
                <InputText type="password" label="Password" v-model="usuario.usu_password"></InputText>
                <InputText type="password" label="Confirmar password" v-model="usuario.usu_confirmed_password"></InputText>
            </div>
        </div>
        <div class="nj-panel-footer">
            <Button label="Crear cuenta" icon="" color="green" @click="crearCuenta()"></Button>
        </div>
    </div>
</div>
</template>
<script>
import { ProveedorService, ResponseStatus } from "../../services"
import { Toast, Tools, Validator } from "../../util"
import { Button, InputText } from "../components"
export default {
    name: "CrearCuenta",
    components: {
        Button,
        InputText,
    },
    data() {
        return {
            proveedor: {
                pve_ruc: null,
                pve_razon_social: null,
                pve_telefono: null,
                pve_correo: null,
                pve_especialidad: null,
                pve_cuenta_detraccion: null,
            },
            usuario: {
                usu_nombre: null,
                usu_apellido: null,
                usu_correo: null,
                usu_password: null,
            }
        }
    },
    methods: {
        obtenerDatos(value) {
            ProveedorService
                .obtenerDatosxRuc({
                    proveedor: {
                        pve_ruc: value
                    }
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        if (Validator.isNotNull(response.data)) {
                            this.proveedor = response.data
                            this.usuario.usu_correo = this.proveedor.pve_correo
                        }
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
        },
        crearCuenta() {
            // * evaluando que se ingresen todos los datos
            if (
                Tools.eval([
                    this.usuario.usu_correo
                    , this.usuario.usu_dni
                    , this.usuario.usu_nombre
                    , this.usuario.usu_apellido
                    , this.usuario.usu_password
                    , this.usuario.usu_confirmed_password
                ])
            ) {
                // * verificando el password
                if (this.usuario.usu_password == this.usuario.usu_confirmed_password) {
                    ProveedorService
                        .crearCuenta({
                            proveedor: {
                                pve_id: this.proveedor.pve_id
                            },
                            usuario: this.usuario
                        })
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.$router.push({
                                    name: "LoginAndEmail",
                                    params: {
                                        email: this.usuario.usu_correo
                                    }
                                })
                            }
                            else {
                                Toast.error(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                        })
                }
                else {
                    Toast.error("El password y la confirmación no coinciden")
                }
            }
            else {
                Toast.error("Faltan ingresar datos del usuario")
            }
        },
        reiniciar() {
            this.proveedor = {
                pve_ruc: null,
                pve_razon_social: null,
                pve_telefono: null,
                pve_correo: null,
                pve_especialidad: null,
                pve_cuenta_detraccion: null,
            }
            this.usuario = {
                usu_nombre: null,
                usu_apellido: null,
                usu_correo: null,
                usu_password: null,
            }
        }
    },
    mounted() {

    }
}
</script>

<style scoped>
.container {
    width: 100%;
    margin: 0 auto;
}

.container> {
    max-width: 1000px;
}
</style>